import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Formulaire } from "../../core/model/formulaire";
import { FormulaireService } from "../../core/service/formulaire.service";

@Component({
  selector: "app-add-formulaire",
  templateUrl: "./add-formulaire.component.html",
  styleUrls: ["./add-formulaire.component.scss"],
})
export class AddFormulaireComponent implements OnInit {
  formulaire: Formulaire = new Formulaire();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _formulaireService: FormulaireService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      lien: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._formulaireService
      .add(this.formulaire)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
